import { Select } from "melco-ui";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { useGetRefferalSalesPersons } from "../../hooks/licensemanager/useRefferalSalesPersons";

type ProductsFilterProps = {
    onChange: (value: string) => void;
    value?: string;
};

const SelectBoxWrapper = styled.div`
  max-width: 300px;
  min-width: 225px;
`;

export const RefferalSalesPersonsFilter: React.FC<ProductsFilterProps> = ({
    value,
    onChange,
}) => {
    const { t } = useTranslation();

    const refferals = useGetRefferalSalesPersons();
    const refferalsOptions = refferals?.data?.list.map(
        (refferal) => ({
            value: refferal.code,
            label: refferal.name,
        })
    );

    return (
        <SelectBoxWrapper>
            <Select
                allowClear
                placeholder={t("licenses.basic.search.refferal_sales_person.title")}
                style={{ width: "100%", minWidth: 150 }}
                maxTagCount={1}
                options={refferalsOptions}
                onChange={onChange}
                value={value}
            />
        </SelectBoxWrapper>
    );
};